import React, { memo, useMemo, useCallback, useEffect, useState } from 'react';
import { Box, Badge } from '@chakra-ui/react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import FiltersHeader from './components/FiltersHeader';
import { Table } from 'components';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import { IParams, getMyAvaliations } from 'services/myAvaliations';
import { IMyAvaliationsGet } from 'types/myAvaliationsGet';
import { avaliations } from 'constants/avaliations';
import { getLoggedUser } from 'utils/storage';
import useEventBus from 'hooks/useEventBus';
import { openNotification } from 'utils/notification';

// import { Container } from './styles';

export const Span = styled.span`
  padding: 20px 15.2rem;
  padding-left: 25px;
  height: 100%;

  &:hover {
    cursor: pointer;
  }
`;

interface IProps extends RouteComponentProps {}

const Page: React.FC<IProps> = ({ history }) => {
  const eventBus = useEventBus();
  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', 'Avaliações');
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const { formId } = useMemo(
    () => ({
      formId: '5',
      ...(queryToObj(history.location.search) as {
        formId?: string;
      }),
    }),
    [history.location.search],
  );

  const [data, setData] = useState<IMyAvaliationsGet>({
    content: [],
  });

  const page = useMemo(() => {
    return queryToObj(history.location.search).page as string | undefined;
  }, [history.location.search]);

  const handleGetData = useCallback(async (query: any) => {
    setIsLoading(true);
    setData(c => ({ ...c, content: [] }));
    try {
      const queryData = {
        size: 10,
        page: 0,
        identificacao: '',
        formId: '5',
        pageable: true,
        ...query,
        clientId: getLoggedUser().client || undefined,
      } as IParams;
      const response = await getMyAvaliations(queryData);

      setData(response.data);
    } catch (error) {
      openNotification('Você não possui acesso a esta função.', 'warn');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handlePaginate = (newPage: number) => {
    const newFilterData = queryToObj(history.location.search);
    const query = objToQuery({ ...newFilterData, page: Math.max(newPage - 1, 0) });
    if (
      newFilterData.page &&
      typeof newFilterData.page === 'string' &&
      newPage - 1 === parseInt(newFilterData.page)
    )
      return;
    history.replace({
      pathname: routePaths.myAvaliations,
      search: `?${query}`,
    });
  };

  useEffect(() => {
    handleGetData(queryToObj(history.location?.search || ''));
    const removeListen = history.listen(listener => handleGetData(queryToObj(listener.search)));

    return () => {
      removeListen();
    };
  }, [history]);

  return (
    <>
      <Box w="100%">
        <FiltersHeader history={history} />
        <Box padding="0.1rem 0rem 1rem" background="#fff" borderRadius="10px">
          <Table
            enabled={[true]}
            id={[0]}
            loading={isLoading}
            headers={['Identificação', 'Avaliação', 'Criado por', 'Há quem pertence', 'Status']}
            sizes={[1.15, 1.15, 1, 1, 0.7]}
            fullLoading={false}
            path={avaliations.find(i => i.value === +formId)?.href}
            row={data.content.map(avaliation => avaliation.id)}
            locations={data.content.map(
              avaliation => `${avaliations.find(i => i.value === +formId)?.href}${avaliation.id}`,
            )}
            rows={data.content.map(avaliation => [
              <Span key={avaliation.id}>
                {avaliation.name.length >= 50 ? avaliation.name.slice(0, 50) : avaliation.name}
              </Span>,
              avaliations.find(i => i.value === +formId)?.label,
              avaliation.createdBy,
              avaliation.client,
              <Badge
                key={avaliation.id}
                backgroundColor={avaliation.completed ? 'brand.green100' : 'brand.blue300'}
                color="brand.white"
                paddingX="10px"
                borderRadius="10px"
              >
                {avaliation.completed ? 'Finalizado' : 'Em andamento'}
              </Badge>,
            ])}
            pagination={{
              initialPage: parseInt('0' + page) + 1,
              onChange: handlePaginate,
              pagesCount: data?.totalPages || 1,
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export const MyAvaliations = memo(Page);
